/* eslint-disable prettier/prettier */
export default {
	// 施設一覧API
	'EAPI00000001': '本機能を利用する権限がありません',
	'EAPI00100001': '施設情報取得時にエラーが発生しました',
	'SAPI00100001': '取得可能な施設情報がありませんでした。',
	'SAPI00100002': '施設一覧の取得完了',
	// 施設詳細API
	'EAPI00200001': '指定されたグループが管理対象でないため表示できません。',
	'EAPI00200002': '施設情報詳細取得時にエラーが発生しました',
	'SAPI00200001': '施設詳細取得完了',
	// 施設更新API
	'EAPI03000001': '施設の管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。',
	'EAPI03000002': '施設の管理者アドレスがユーザ情報に登録されていません。システム管理者にご連絡ください。',
	'EAPI03000003': '店舗の管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。',
	'EAPI03000005': '施設情報更新時にエラーが発生しました',
	'SAPI00300001': '施設情報の更新完了',
	// 施設登録API
	'EAPI03000006': '施設情報登録時にエラーが発生しました',
	'SAPI00300002': '施設情報の登録完了',
	// 施設削除API
	'EAPI00400001': '施設情報削除時にエラーが発生しました',
	'SAPI00400001': '施設情報の削除完了',
	// 店舗一覧API
	'EAPI00000003': '指定された店舗が管理対象店舗でないため検索・表示できません。',
	'EAPI00000004': 'リクエストの形式が異なるため処理できません',
	'EAPI01100001': '店舗情報取得時にエラーが発生しました',
	'SAPI01100001': '管理している店舗がありません',
	'SAPI01100002': '店舗情報取得完了',
	// 店舗詳細API
	'EAPI00000002': '指定された店舗が管理対象店舗でないため表示できません。',
	'EAPI01200001': '店舗情報詳細取得時にエラーが発生しました',
	'SAPI01200001': '店舗詳細取得完了',
	// 店舗更新API
	'EAPI01300001': '店舗の副管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。',
	'EAPI01300002': '店舗情報更新時にエラーが発生しました',
	'SAPI01300001': '店舗情報の更新完了',
	// 店舗削除API
	'EAPI01400001': '店舗情報削除時にエラーが発生しました',
	'SAPI01400001': '店舗情報の削除完了',
	// 管理店舗一覧API
	'EAPI01500001': '管理情報に基づく店舗一覧取得時にエラーが発生しました',
	'SAPI01500001': '管理情報に基づく店舗一覧取得完了',
	// 加入者店舗集計API
	'EAPI01600001': '加入店舗数取得時にエラーが発生しました',
	'SAPI01600001': '加入店舗数取得完了',
	// 店舗確認一覧API
	'EAPI02100001': '店舗確認一覧取得時にエラーが発生しました',
	'SAPI02100001': '確認可能な店舗/学校/病院が存在しません。',
	'SAPI02100002': '店舗確認一覧取得完了',
	// 店舗確認登録API
	'EAPI02300001': '会社名が登録された施設の管理者になっていないため確認処理を行うことができません',
	'EAPI02300004': '施設の管理者になっていないため確認処理を行うことができません',
	'EAPI02300002': '管理者アドレスがユーザ情報として2件以上登録されています。システム管理者にご連絡ください。',
	'EAPI02300003': '店舗確認登録時にエラーが発生しました',
	'SAPI02300001': 'ユーザ情報が登録されていません。',
	// 画像一覧取得API
	'EAPI03100001': '画像一覧取得時にエラーが発生しました',
	'SAPI03100001': '画像一覧取得完了',
	// 画像アップロードAPI
	'EAPI03200001': '画像のサイズが制限値を超えています。',
	'EAPI03200002': '画像のファイルサイズが制限値を超えています。',
	'EAPI03200003': '画像アップロード時にエラーが発生しました',
	'SAPI03200001': '店舗画像アップロード完了',
	// 画像削除API
	'EAPI03300001': '画像更新(削除予定)時にエラーが発生しました',
	'SAPI03300001': '店舗画像を削除予定に更新完了',
	// ユーザー一覧API
	'EAPI00000006': 'ユーザ情報取得時にエラーが発生しました',
	'SAPI00000001': 'ユーザ情報の取得完了',
	// ユーザー更新API
	'EAPI04200001': 'すでに登録されているメールアドレスのため更新できません',
	'EAPI04200002': 'ユーザ情報更新時にエラーが発生しました',
	'SAPI04200001': 'ユーザー情報の更新完了',
	// ユーザー登録API
	'EAPI04200003': 'すでに登録されているメールアドレスのため登録できません',
	'EAPI04200004': 'ユーザ情報登録時にエラーが発生しました',
	'SAPI04200002': 'ユーザー情報が登録されました。',
	// ユーザー削除API
	'EAPI04300001': 'リセラー管理者もしくは施設・店舗の代表管理者となってるため削除できません。',
	'EAPI04300002': 'ユーザ情報削除時にエラーが発生しました',
	'SAPI04300001': 'ユーザー情報の削除完了',
	// ユーザー権限取得API
	'EAPI04400001': 'ユーザ権限取得時にエラーが発生しました',
	'SAPI04400001': 'ユーザ権限取得完了',
	// ユーザー詳細API
	'EAPI04500001': 'ユーザー詳細取得時にエラーが発生しました',
	'SAPI04500001': 'ユーザー詳細取得完了',
	// センサ紐づけ登録API（解除）
	'EAPI05100001': '代表センサーを削除することはできません。他のセンサーに代表センサーに変更した後、再度実施してください。',
	'EAPI05100002': 'センサー紐づけ解除時にエラーが発生しました',
	'SAPI05100001': 'センサの紐づけ解除完了',
	// センサ紐づけ登録API（登録）
	'EAPI05100003': 'センサーへの紐づけ登録ができません。センサー端末画面で「Registration」をクリックしてください。',
	'EAPI05100004': '他の店舗・学校・病院で代表センサーとなっているため、対象センサーの紐づけ解除後に再度登録を実施してください。',
	'EAPI05100005': '店舗・学校・病院のセンサーの登録を先に行ってください。',
	'EAPI05100006': 'センサー紐づけ登録時にエラーが発生しました',
	'EAPI05100007': '他の店舗・学校・病院に紐づいているセンサーのため紐づけできません。',
	'SAPI05100002': 'センサーの紐づけ登録完了',
	'SAPI05100003': '特別な権限で強制的にセンサーを部屋に接続しました。<br>接続に誤りがないか必ず確認してください。',
	// センサ公開設定API
	'EAPI05200001': '代表センサーは店舗・学校・病院にのみ設定可能です。',
	'EAPI05200002': '代表センサーには公開中のセンサーを選択してください。',
	'EAPI05200003': '代表センサーを非公開にすることはできません。公開設定を行ってください。',
	'EAPI05200004': '代表センサーを公開した後、再度実施してください。',
	'EAPI05200005': '代表センサーを未設定にすることはできません。',
	'EAPI05200006': 'リクエストの形式が異なるため処理することができません。',
	'EAPI05200007': 'センサー公開設定にてエラーが発生しました',
	'SAPI05200001': 'センサー公開設定完了',
	// センサー一覧取得API
	'EAPI05300001': 'センサー一覧取得時にエラーが発生しました',
	'SAPI05300001': 'センサー情報がありませんでした',
	'SAPI05300002': 'センサー一覧取得完了',
	// センサー詳細取得API
	'EAPI05400001': '指定されたセンサーの紐づけ店舗が管理対象店舗でないため表示できません。',
	'EAPI05400002': 'センサー詳細情報取得時にエラーが発生しました',
	'SAPI05400001': 'センサー詳細情報を取得できませんでした',
	'SAPI05400002': 'センサー詳細取得完了',
	// センサー計測情報取得API
	'EAPI05500001': 'センサー計測情報取得時にエラーが発生しました',
	'SAPI05500001': 'センサー計測情報取得完了',
	'SAPI05500002': '対象のIoTデータ情報が存在しません',
	// センサー設定情報取得API
	'EAPI05600001': '指定されたセンサの紐づけ店舗が管理対象店舗でないため表示できません。',
	'EAPI05600002': 'センサー設定情報取得時にエラーが発生しました',
	'SAPI05600001': 'センサー設定情報を取得できませんでした',
	'SAPI05600002': 'センサー設定情報取得完了',
	// 店舗センサー一覧取得API
	'EAPI05700001': '店舗紐づけセンサー一覧取得時にエラーが発生しました',
	'SAPI05700001': '店舗センサー一覧情報を取得できませんでした',
	'SAPI05700002': '店舗紐づけセンサー一覧取得完了',
	// 部屋情報削除API
	'EAPI06200001': '部屋削除時にエラーが発生しました',
	'SAPI06200001': '削除対象のデータがありません',
	'SAPI06200002': '部屋情報削除完了',
	// 店舗部屋一覧取得API
	'EAPI06300001': '部屋一覧取得時にエラーが発生しました',
	'SAPI06300001': '管理可能な部屋がありません',
	'SAPI06300002': '部屋一覧取得完了',
	// セキュリティ詳細取得API
	'EAPI07100001': 'セキュリティ詳細情報取得時にエラーが発生しました',
	'SAPI07100001': 'セキュリティ詳細情報取得完了',
	// セキュリティ更新API
	'EAPI07200001': 'セキュリティ情報更新時にエラーが発生しました',
	'SAPI07200001': 'セキュリティ更新完了',
	// お知らせ一覧取得API
	'EAPI08100001': 'お知らせ情報取得時にエラーが発生しました',
	'SAPI08100001': 'お知らせ情報取得完了',
	// お知らせ詳細情報取得API
	'EAPI08200001': '取得できるお知らせ情報がありません',
	'EAPI08200002': 'お知らせ詳細情報取得時にエラーが発生しました',
	'SAPI08200001': 'お知らせ詳細情報取得完了',
	// お知らせ情報登録API
	'EAPI08300001': 'お知らせ情報登録時にエラーが発生しました',
	'SAPI08300001': 'お知らせ情報登録完了',
	// お知らせ情報更新API
	'EAPI08300002': '更新対象のお知らせ情報が存在しませんでした。',
	'EAPI08300003': 'お知らせ情報更新時にエラーが発生しました',
	'SAPI08300002': 'お知らせ情報更新完了',
	// お知らせ情報削除API
	'EAPI08400001': '削除対象のお知らせ情報が存在しませんでした。',
	'EAPI08400002': 'お知らせ情報削除時にエラーが発生しました',
	'SAPI08400001': 'お知らせ情報の削除完了',
	// ダウンロード一覧取得API
	'EAPI10100001': 'ダウンロード情報取得時にエラーが発生しました',
	'SAPI10100001': 'ダウンロード情報がありませんでした',
	'SAPI10100002': 'ダウンロード情報取得完了',
	// センサーデータダウンロードAPI
	'EAPI10200001': 'センサーデータがダウンロード可能状態でありません。',
	'EAPI10200002': 'センサーデータダウンロード時にエラーが発生しました',
	'SAPI10200001': 'presigned-URLの取得完了',
	// センサデータ出力API
	'EAPI10300001': '出力期間は過去となるように選択してください。',
	'EAPI10300002': 'ダウンロード情報登録時にエラーが発生しました',
	'SAPI10300001': 'ダウンロード情報の登録完了',
	// ダウンロード情報削除API
	'EAPI10400001': 'センサーデータ削除時にエラーが発生しました',
	'SAPI10400001': 'ダウンロード情報の削除完了',
	// セキュリティユーザー一覧取得API
	'EAPI11100001': '管理対象店舗でないため表示できません。',
	'EAPI11100002': 'セキュリティユーザー一覧取得時にエラーが発生しました',
	'SAPI11100001': 'セキュリティユーザーが存在しません。',
	'SAPI11100002': 'セキュリティユーザー一覧取得完了',
	// セキュリティユーザー情報削除API
	'EAPI11200001': '削除モードが不正です',
	'EAPI11200002': 'セキュリティユーザー削除時にエラーが発生しました。',
	'SAPI11200001': 'セキュリティユーザー削除完了',
	// 埋め込みHTML設定情報一覧API
	'EAPI12100001': '埋め込みHTML設定情報一覧取得時にエラーが発生しました',
	'SAPI12100001': '埋め込みHTML設定情報一覧取得完了',
	// 埋め込みHTML設定情報取得API
	'EAPI12200001': '埋め込みHTML設定情報がありません',
	'EAPI12200002': '埋め込みHTML設定情報取得時にエラーが発生しました',
	'SAPI12200001': '埋め込みHTML設定情報取得完了',
	// 埋め込みHTML設定情報更新API
	'EAPI00000005': '対象の設定情報が存在しません。',
	'EAPI12300001': 'センサーの設定数が不正です',
	'EAPI12300002': '表示項目の設定数が不正です',
	'EAPI12300003': '表示タイプの設定値が不正です',
	'EAPI12300004': '表示カラーの設定値が不正です',
	'EAPI12300005': '管理者でないため更新できません。',
	'EAPI12300007': '埋め込みHTML設定情報更新時にエラーが発生しました',
	'SAPI12300001': '埋め込みHTML設定情報の更新完了',
	// 埋め込みHTML設定情報登録API
	'EAPI12300006': '管理者でないため登録できません。',
	'EAPI12300008': '埋め込みHTML設定情報登録時にエラーが発生しました',
	'SAPI12300002': '埋め込みHTML設定情報の登録完了',
	// 埋め込みHTML設定情報削除API
	'EAPI12400001': '管理者でないため削除できません。',
	'EAPI12400002': '埋め込みHTML設定情報削除時にエラーが発生しました',
	'SAPI12400001': '埋め込みHTML設定情報の削除完了',
	// アンケート回答年月取得API
	'EAPI14200001': '必須パラメータの施設ID、区画IDがリクエストに含まれていません。',
	'EAPI14200002': '施設IDの型がinteger型ではありません。',
	'EAPI14200003': '区画IDの型がinteger型ではありません。',
	'EAPI14200004': 'アンケート回答年月情報取得時にエラーが発生しました。',
	'SAPI14200001': 'アンケート回答年月情報の取得が完了しました。',
	'SAPI14200002': 'アンケート回答年月情報がありません。',
	// アンケート結果ダウンロード情報取得API
	'EAPI14300001': 'アンケートダウンロード情報取得時にエラーが発生しました',
	'SAPI14300001': 'アンケート結果ダウンロード情報がありません',
	'SAPI14300002': 'アンケートダウンロード情報取得完了',
	// アンケート結果ダウンロードAPI
	'EAPI14400001': 'アンケート結果がダウンロード可能状態でありません',
	'EAPI14400002': 'アンケート結果ZIPのpresigned-URLの取得時にエラーが発生しました',
	'SAPI14400001': 'アンケート結果ZIPのpresigned-URLの取得完了',
	// アンケート結果出力API
	'EAPI14500001': 'アンケート結果出力時にエラーが発生しました',
	'SAPI14500001': 'アンケート結果出力の登録完了',
	// アンケート結果ダウンロード削除API
	'EAPI14600001': 'アンケート結果出力データ削除時にエラーが発生しました',
	'SAPI14600001': 'アンケート結果出力データの削除完了',
	// 施設向けレポートダウンロードAPI
	'SAPI15100002': 'ダウンロード可能なレポートがありません。',
	'SAPI15100001': 'presigned-URLの取得完了',
	'EAPI15100001': '施設向けレポートのダウンロード時にエラーが発生しました',
	// 店舗向けレポートダウンロードAPI
	'SAPI15200001': 'presigned-URLの取得完了',
	'EAPI15200001': '店舗向けレポートのダウンロード時にエラーが発生しました',
	// 店舗向けレポート一括ダウンロードAPI
	'SAPI15300001': 'presigned-URLの取得完了',
	'EAPI15300001': '店舗向けレポート一括ダウンロード時にエラーが発生しました',

	// リセラー管理
	'EAPI16100001': 'リセラー一覧取得時にエラーが発生しました。',
	'SAPI16100001': 'リセラー一覧取得完了',
	'SAPI16100002': '表示可能なリセラーが存在しません。',
	'EAPI16200001': 'リセラー詳細取得時にエラーが発生しました。',
	'EAPI16200002': '対象のリセラー情報が存在しない、もしくは選択中のリセラーでは表示できません。',
	'EAPI16200003': '対象のリセラー情報を表示する権限がありません。',
	'SAPI16200001': '対象のリセラー情報が存在しません。',
	'SAPI16200002': 'リセラー詳細取得完了',
	'EAPI16300001': '既に他のリセラーの管理者となっているためリセラー管理者に登録できません。',
	'EAPI16300002': '管理者アドレスがリセラー管理者情報として2件以上登録されています。システム管理者にご連絡ください。',
	'EAPI16300003': '同じメールアドレスが複数件リセラー管理者に設定されています。',
	'EAPI16300007': 'リセラー登録時にエラーが発生しました。',
	'EAPI16300004': 'リセラー更新時にエラーが発生しました。',
	'EAPI16300005': '対象のリセラー情報を登録・更新する権限がありません。',
	'EAPI16300006': '更新対象のリセラー情報が存在しません。',
	'SAPI16300001': 'リセラー登録完了',
	'SAPI16300002': 'リセラー更新完了',
	'EAPI16400001': '管理しているリセラー情報があるため、削除できません。',
	'EAPI16400002': '管理している施設情報があるため、削除できません。',
	'EAPI16400003': '削除対象のリセラー情報が存在しません。',
	'EAPI16400004': 'リセラー削除時にエラーが発生しました。',
	'SAPI16400001': 'リセラー削除完了',
	
	// リセラー情報取得ファンクション
	'EAPI00000007': 'リセラー情報取得時にエラーが発生しました',
	
}
